import { useAtomValue } from 'jotai'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useBlocker } from 'react-router'
import { useBeforeUnload } from 'react-use'

import { Suspense } from '~/components/elements/Suspense'
import { checkCurrentSurvey } from '~/hoc/checkCurrentSurvey'
import { useLogEventOnMount } from '~/hooks/useLogEventOnMount'
import { useSurveyQuery } from '~/hooks/useSurveyQuery'

import {
  fiveSegmentCommentAtom,
  nineSegmentCommentAtom,
  savedFiveSegmentCommentAtom,
  savedNineSegmentCommentAtom,
} from './atoms'
import { CustomerAnalysis } from './components/CustomerAnalysis'
import { useResetOnUnmount } from './hooks/useResetOnUnmount'

export const CustomerAnalysisPage = checkCurrentSurvey(() => {
  const { t } = useTranslation()
  const { isLoading } = useSurveyQuery()
  const fiveSegmentComment = useAtomValue(fiveSegmentCommentAtom)
  const nineSegmentComment = useAtomValue(nineSegmentCommentAtom)
  const savedFiveSegmentComment = useAtomValue(savedFiveSegmentCommentAtom)
  const savedNineSegmentComment = useAtomValue(savedNineSegmentCommentAtom)
  const isDirty =
    fiveSegmentComment !== savedFiveSegmentComment ||
    nineSegmentComment !== savedNineSegmentComment
  const dirtyMessage = t(
    'edited_content_has_not_been_saved_do_you_still_want_to_leave',
  )

  const blocker = useBlocker(
    ({ currentLocation, nextLocation }) =>
      isDirty && currentLocation.pathname !== nextLocation.pathname,
  )

  useBeforeUnload(isDirty, dirtyMessage)
  useLogEventOnMount('Access to 9segs distribution function')
  useResetOnUnmount()

  React.useEffect(() => {
    if (blocker.state === 'blocked') {
      const isConfirmed = window.confirm(dirtyMessage)
      if (isConfirmed) {
        blocker.proceed()
      } else {
        blocker.reset()
      }
    }
  }, [blocker, dirtyMessage])

  return (
    <Suspense loading={isLoading}>
      <CustomerAnalysis />
    </Suspense>
  )
})
